/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Next_StepsInputs */

const en_directory_resources_next_steps = /** @type {(inputs: Directory_Resources_Next_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next steps`)
};

const zh_directory_resources_next_steps = /** @type {(inputs: Directory_Resources_Next_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一步`)
};

/**
* | output |
* | --- |
* | "Next steps" |
*
* @param {Directory_Resources_Next_StepsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_next_steps = /** @type {((inputs?: Directory_Resources_Next_StepsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Next_StepsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_next_steps(inputs)
	return zh_directory_resources_next_steps(inputs)
});
export { directory_resources_next_steps as "directory.resources.next_steps" }